/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-05-30 11:02:04
 * @LastEditors: 317473294@qq.com
 * @LastEditTime: 2023-09-19 22:41:51
 * @FilePath: /english_admin_v1.1.0/src/api/kyWord.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
//导入请求拦截与响应拦截，每次请求，都会经过请求拦截，请求结束会产生响应拦截，
import Axios from "../axios/index.js"


//单词列表接口
export function wordList(data){
    console.log(data)
return Axios({
    method:"get",
    url:"api/list",
    params:data
})
}     
//删除单词
export function deleteWord(data){
    return Axios({
        method:"post",
        url:"api/delete/",
        data:data
    })
    }  

    //编辑单词
export function editWord(data){
    return Axios({
        method:"post",
        url:"api/edit",
        data:data
    })
    }     
    //添加爬虫网络单词
export function addWord(data){
    return Axios({
        method:"post",
        url:"api/addnetword",
        data:data
    })
    }
            //手动添加单词getVogueWordAndZw
    export function addHandWrod(data){
        return Axios({
            method:"post",
            url:"api/addHandWord",
            data:data
        })
        }

      //单词模糊查询
    export function getVogueWordAndZw(data){
        return Axios({
            method:"post",
            url:"api/getVogueWordAndZw",
            data:data
        })
        }


// WEBPACK FOOTER //
// ./src/api/kyword.js